import lid from './lidAuth.component';
import stLidButton from './LidButton.component';

export default angular
  .module('st.Integrations.LID', ['st.Core', 'angular-cache'])
  .component('lid', lid)
  .component('stLidButton', stLidButton)
  .service('lidService', ($http, dataService, LID) => ({
    send: (params) =>
      dataService.apiRequest(
        null,
        null,
        true,
        null,
        $http.post,
        LID.API.REFER,
        {
          params
        },
        null,
        true
      )
  }))
  .constant('LID', {
    API: {
      REFER: '/api/v1/integration/lid/refer'
    },
    QUESTIONS: {
      YES_NO: [
        { id: 'Yes', value: 'Yes' },
        { id: 'No', value: 'No' }
      ],
      GENDER: [
        { id: 'Male', value: 'Male' },
        { id: 'Female', value: 'Female' }
      ],
      QUOTE_TYPE: [
        { id: '', value: 'Select one' },
        { id: 'Life Insurance', value: 'Life Insurance' },
        { id: 'Income Protection', value: 'Income Protection' },
        { id: 'Trauma Insurance', value: 'Trauma Insurance' },
        { id: 'TPD Insurance', value: 'TPD Insurance' },
        { id: 'Keyman Insurance', value: 'Keyman Insurance' }
      ],
      HOURS: [
        {
          option: 'Choose time',
          value: 0,
          isDisabled: true
        },
        {
          option: '00:30 AM',
          value: 1800
        },
        {
          option: '01:00 AM',
          value: 3600
        },
        {
          option: '01:30 AM',
          value: 5400
        },
        {
          option: '02:00 AM',
          value: 7200
        },
        {
          option: '02:30 AM',
          value: 9000
        },
        {
          option: '03:00 AM',
          value: 10800
        },
        {
          option: '03:30 AM',
          value: 12600
        },
        {
          option: '04:00 AM',
          value: 14400
        },
        {
          option: '04:30 AM',
          value: 16200
        },
        {
          option: '05:00 AM',
          value: 18000
        },
        {
          option: '05:30 AM',
          value: 19800
        },
        {
          option: '06:00 AM',
          value: 21600
        },
        {
          option: '06:30 AM',
          value: 23400
        },
        {
          option: '07:00 AM',
          value: 25200
        },
        {
          option: '07:30 AM',
          value: 27000
        },
        {
          option: '08:00 AM',
          value: 28800
        },
        {
          option: '08:30 AM',
          value: 30600
        },
        {
          option: '09:00 AM',
          value: 32400
        },
        {
          option: '09:30 AM',
          value: 34200
        },
        {
          option: '10:00 AM',
          value: 36000
        },
        {
          option: '10:30 AM',
          value: 37800
        },
        {
          option: '11:00 AM',
          value: 39600
        },
        {
          option: '11:30 AM',
          value: 41400
        },
        {
          option: '12:00 PM',
          value: 43200
        },
        {
          option: '12:30 PM',
          value: 45000
        },
        {
          option: '01:00 PM',
          value: 46800
        },
        {
          option: '01:30 PM',
          value: 48600
        },
        {
          option: '02:00 PM',
          value: 50400
        },
        {
          option: '02:30 PM',
          value: 52200
        },
        {
          option: '03:00 PM',
          value: 54000
        },
        {
          option: '03:30 PM',
          value: 55800
        },
        {
          option: '04:00 PM',
          value: 57600
        },
        {
          option: '04:30 PM',
          value: 59400
        },
        {
          option: '05:00 PM',
          value: 61200
        },
        {
          option: '05:30 PM',
          value: 63000
        },
        {
          option: '06:00 PM',
          value: 64800
        },
        {
          option: '06:30 PM',
          value: 66600
        },
        {
          option: '07:00 PM',
          value: 68400
        },
        {
          option: '07:30 PM',
          value: 70200
        },
        {
          option: '08:00 PM',
          value: 72000
        },
        {
          option: '08:30 PM',
          value: 73800
        },
        {
          option: '09:00 PM',
          value: 75600
        },
        {
          option: '09:30 PM',
          value: 77400
        },
        {
          option: '10:00 PM',
          value: 79200
        },
        {
          option: '10:30 PM',
          value: 81000
        },
        {
          option: '11:00 PM',
          value: 82800
        },
        {
          option: '11:30 PM',
          value: 84600
        }
      ]
    }
  });
